import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import { Link } from 'react-router';
import { getCanonicalURL } from 'common/utils';
import { Meta } from 'common/components/meta';
import { SelectField } from 'common/components/form_fields';
import Support from 'marketing/containers/support';
import {
  trackMixpanel, trackClickWithMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
  MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME
} from 'common/tracking';

export default class CaseStudies extends Component {
  constructor(props) {
    super(props);

    this.state = { selectedSubcat: 'all' };

    this.selectSubcat = this.selectSubcat.bind(this);
  }

  componentDidMount() {
    this.props.fetchCaseStudies();

    trackMixpanel(MP_VIEWED_MARKETING_PAGE_EVENT_NAME, {
      "pageName": "Case Studies"
    });
  }

  selectSubcat(subCat) {
    this.setState({ selectedSubcat: subCat });
  }

  render() {
    const { selectedSubcat } = this.state;
    const { subCategories, items } = this.props;
    const subCatOptions = [
      { field: 'all', label: 'All Categories' },
      ...subCategories.map(subCat => ({ field: subCat.id, label: subCat.name })),
    ];
    const currentItems = (
      selectedSubcat === 'all'? items :
      items.filter(item => item.subcategories.includes(parseInt(selectedSubcat)))
    );

    return (
      <div id="content" className="l-content">
        <Meta
          title="Case Studies"
          meta={[
            { name: 'robots', content: 'index,follow' },
            { name: 'description', content: "You're in good company. Tens of thousands of leadings businesses, agencies and non-profits use crowdspring to grow their businesses through beautiful design." },
            { name: 'keywords', content: 'case-studies, stories, customer reviews, testimonials, crowdspring reviews' },
            { property: 'og:title', content: 'Case Studies' },
            { property: 'og:url', content: getCanonicalURL('/case-studies/') },
          ]}
          link={[{ rel: 'canonical', href: getCanonicalURL('/case-studies/') }]} />
        <section className="block block-hero">
          <div className="row">
            <div className="small-16 medium-8 columns">
              <h1 className="hero-title">See how we help businesses grow</h1>
              <h3 className="hero-subtitle">
                More than 60,000 of the world's best entrepreneurs, businesses, agencies and
                non-profits love crowdspring. Here are some of their stories.
              </h3>
              <div className="hero-actions">
                <Link to="/how-it-works/" className="btn btn-text">
                  How crowdspring works <i className="fa fa-long-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="block block-case-studies">
          <div className="row header-row hide">
            <div className="columns small-16 large-11">
              <h3>Show customer stories for </h3>
              <SelectField meta={{}} options={subCatOptions} input={{
                onChange: (e) => this.selectSubcat(e.target.value),
                value: selectedSubcat
              }} />
            </div>
            <div className="columns small-16 large-5">
              { selectedSubcat !== "all" &&
              <a className="pull-right" onClick={partial(this.selectSubcat, 'all')}>
                See all {items.length} customer stories
              </a> }
            </div>
          </div>
          <div className="row">
            { currentItems.map(item => (
            <div key={item.id} className="columns small-16 medium-8">
              <Link to={item.story_path} key={item.id}>
                <div className="item">
                  <div className="client">{ item.client_name }</div>
                  <h3 className="title">{ item.title }</h3>
                  <div className="image" style={{ backgroundImage: `url(${item.image_link})` }} />
                  <div className="cta">
                    Read Story <i className="fa fa-align-left pull-right"/>
                  </div>
                </div>
              </Link>
            </div> )) }
          </div>
        </section>
        <section className="block block-clients">
          <div className="row columns">
            <div className="block-header">
              <h2> More companies that love crowdspring.</h2>
            </div>
          </div>
          <div className="row">
            <div className="small-8 medium-4 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_amazon-2x.jpg" alt="Amazon" />
            </div>
            <div className="small-8 medium-4 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_aliexpress-2x.jpg" alt="AliExpress" />
            </div>
            <div className="small-8 medium-4 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_lg-2x.jpg" alt="LG" />
            </div>
            <div className="small-8 medium-4 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_starbucks-2x.jpg" alt="Starbucks" />
            </div>
          </div>
          <div className="row align-center">
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_barilla-2x.jpg" alt="Barilla" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_brammo-2x.jpg" alt="Brammo" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_citysearch-2x.jpg" alt="Citysearch" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_fcb-2x.jpg" alt="FCB" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_grolsch-2x.jpg" alt="Grolsch" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_madison-childrens-2x.jpg" alt="Madison Children's Museum" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_st-croix-chocolate-2x.jpg" alt="St. Croix Chocolate Co." />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_tivo-2x.jpg" alt="Tivo" />
            </div>
          </div>
        </section>
        <Support
          consultationEventTracking={{
            eventName: MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME,
            eventData: {
              pageName: "Case Studies",
              version: "english",
              pageArea: "Support footer",
            }
          }}
        />
      </div>
    );
  }
}

CaseStudies.propTypes = {
  subCategories: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
  fetchCaseStudies: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./marketing/components/case_studies.jsx